(() => {
  if (window.hooniesVehicleFitmentLoader) return;

  const normalise = (value) => (value || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
  const normaliseHandle = (value) => normalise(value)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

  const chunkPromises = new Map();

  const index = () => window.hooniesVehicleFitments || {};

  const chunkUrl = (makeHandle) => {
    const manifest = index();
    const chunk = manifest.chunks?.[makeHandle];
    if (!chunk?.asset) return '';

    const indexUrl = window.hooniesVehicleFitmentIndexUrl || '';
    if (!indexUrl) return chunk.asset;

    try {
      const url = new URL(indexUrl, window.location.href);
      const pathname = url.pathname;
      url.pathname = pathname.slice(0, pathname.lastIndexOf('/') + 1) + chunk.asset;
      return url.toString();
    } catch (error) {
      const base = indexUrl.slice(0, indexUrl.lastIndexOf('/') + 1);
      return `${base}${chunk.asset}`;
    }
  };

  const routeKey = (route) => [
    route.vehicleId || route.bucketId || '',
    route.makeHandle || normaliseHandle(route.make),
    route.modelHandle || normaliseHandle(route.model),
    route.yearHandle || normaliseHandle(route.year || 'All supported years'),
  ].join('|');

  const mergeRoutes = (routes) => {
    const manifest = index();
    if (!Array.isArray(manifest.routes)) {
      manifest.routes = [];
      window.hooniesVehicleFitments = manifest;
    }

    const routeIndex = new Map(manifest.routes.map((route, routeOffset) => [routeKey(route), routeOffset]));

    routes.forEach((route) => {
      const key = routeKey(route);
      const existingIndex = routeIndex.get(key);
      if (existingIndex === undefined) {
        routeIndex.set(key, manifest.routes.length);
        manifest.routes.push(route);
        return;
      }

      manifest.routes[existingIndex] = {
        ...manifest.routes[existingIndex],
        ...route,
      };
    });
  };

  const loadMake = async (make) => {
    const makeHandle = normaliseHandle(make);
    if (!makeHandle) return [];
    if (window.hooniesVehicleData) {
      await window.hooniesVehicleData.make(makeHandle);
      return (index().routes || []).filter(route => route.makeHandle === makeHandle);
    }

    const manifest = index();
    const alreadyLoaded = manifest.loadedChunks?.[makeHandle];
    if (alreadyLoaded) {
      return (manifest.routes || []).filter((route) => (route.makeHandle || normaliseHandle(route.make)) === makeHandle);
    }

    if (chunkPromises.has(makeHandle)) return chunkPromises.get(makeHandle);

    const promise = (async () => {
      const url = chunkUrl(makeHandle);
      if (!url) return [];

      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`Could not load vehicle fitment chunk ${makeHandle}`);
      }

      const chunk = await response.json();
      const routes = Array.isArray(chunk.routes) ? chunk.routes : [];
      mergeRoutes(routes);

      const current = index();
      current.loadedChunks = {
        ...(current.loadedChunks || {}),
        [makeHandle]: true,
      };

      return routes;
    })();

    chunkPromises.set(makeHandle, promise);

    try {
      return await promise;
    } finally {
      chunkPromises.delete(makeHandle);
    }
  };

  const loadRoutesForMatches = async (routes) => {
    const makeHandles = [...new Set(
      routes
        .map((route) => route.makeHandle || normaliseHandle(route.make))
        .filter(Boolean)
    )];

    await Promise.all(makeHandles.map(loadMake));

    const detailByKey = new Map((index().routes || []).map((route) => [routeKey(route), route]));
    return routes.map((route) => detailByKey.get(routeKey(route)) || route);
  };

  window.hooniesVehicleFitmentLoader = {
    loadMake,
    loadRoutesForMatches,
  };
})();
